import { UNSAFE_useOverridableFocusScope } from '@procore/core-react'
import { useEffect } from 'react'

const isCKEditorFloatingUIOpen = () =>
  !!document.querySelector('.ck-dialog-overlay, .ck-balloon-panel_visible')

/**
 * When TextEditor is inside a Modal or Tearsheet, React Aria's FocusScope
 * traps focus within the dialog. CKEditor renders floating UI (link dialogs,
 * table pickers, color pickers) into a portal outside the Modal DOM tree,
 * so focus cannot reach them. This hook dynamically disables focus containment
 * while a CKEditor floating element is visible and re-enables it when closed.
 *
 * Safe to call outside Modal/Tearsheet — the context defaults to a no-op
 * setProps (see FocusScopeOverride.tsx), so this hook silently does nothing.
 */
export function useCKEditorFocusScope() {
  const { setProps } = UNSAFE_useOverridableFocusScope()

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setProps({ contain: !isCKEditorFloatingUIOpen() })
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    return () => observer.disconnect()
  }, [setProps])
}
